export const SUPER_ADMIN_ROLE_CODE = "SUPER_ADMIN";

export function normalizeRoleCode(role) {
  if (typeof role === "string") {
    return role;
  }

  return role?.roleCode || role?.role_code || null;
}

export function isSuperAdminUser(user) {
  if (!user) {
    return false;
  }

  if (user.isSuperAdmin === true) {
    return true;
  }

  if (!user.roles?.length) {
    return false;
  }

  return user.roles.some(
    (role) => normalizeRoleCode(role) === SUPER_ADMIN_ROLE_CODE
  );
}
